
export enum AccountingStatus {
    Pending = 'Pending',
    Success = 'Success',
    Error = 'Error'
}

export enum AccountingSystem {
    Xero = 'Xero',
    MYOB = 'Myob',
    QuickBooks = 'QuickBooks',
    Manual = 'Manual',
    Jobpac =  'Viewpoint Jobpac Connect'
}

export enum TaxType {
    GSTOnImport = 'GSTONIMPORTS',
    TaxOnPurchase = 'INPUT',
    TaxExempt = 'NONE',
    TaxOnSale = 'OUTPUT'
}

export enum TrackingCategory {
    JobType = 'Job Type',
    Customer = 'Customer',
    JobPriority = 'Job Priority',
    StageCategory = 'Stage Category',
    ItemCategory = 'Item Category',
    ItemSubCategory = 'Item Subcategory',
    CatalogueTracking1 = 'Item Tracking Category 1',
    CatalogueTracking2 = 'Item Tracking Category 2'
}

export enum MappingTrackingCategory {
    TrackingCategory1 = 'trackingCategory1',
    TrackingCategory2 = 'trackingCategory2'
}

